import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Mediator = require("../mediator");

import symbologyTemplate = require("./symbology-template");

const defaultSymbol = <Portal.MapIconConfigElement> {
    id: "*",
    Label: "No Rules Found",
    type: "style",
    style: JSON.stringify({
        "type": "sfs",
        "style": "solid",
        "color": [255, 197, 103, 0.5],
        "outline": {
            "type": "sls",
            "style": "solid",
            "color": [0, 0, 0, 1],
            "width": 1
        }
    })
};

// this is not a typical template because it requires access to the mediator
// the constructor has to instaniate it and then use the "transform" method
class Template {

    static transform(args: {
        gimme: (key: string) => any;
        items: Array<Portal.FeatureLeaf>;
    }) {
        if (!args.gimme) throw "the view must implement 'gimme' so the template can access the mediator";

        let mediator = <Mediator>args.gimme("mediator");
        if (!mediator) throw "the view must have a mediator";

        let getIcons = symbology => {
            let symbols = args.items
                .filter(f => Utils.extend(f).symbology === symbology)
                .map(f => {
                    let options = Utils.asDictionary(f.Options ? f.Options.Values : []);
                    let attrs = Utils.asDictionary(f.Attributes ? f.Attributes.Values : []);
                    let rule = options["symbology"] || "*";
                    let symbol = mediator.api.symbology.findSymbol(rule, attrs);
                    if (!symbol) {
                        console.warn("could not find symbology for rule: ", rule);
                        symbol = defaultSymbol
                    }
                    return symbol;
                });

            return _.unique(symbols);
        }

        let symbologies = _.unique(args.items, item => Utils.extend(item).symbology)
            .map(item => {
                let symbology = Utils.extend(item).symbology;
                let icons = getIcons(symbology);
                return <Portal.MonikerSymbologyElement>{
                    Label: symbology,
                    Icons: icons
                };
            });

        return symbologyTemplate({ items: symbologies });
    }
}


export = Template.transform;
